import LetsAdminTemplate from '../router/template/LetsAdminTemplate.vue'

export default [
  {
    path: '/',
    component: LetsAdminTemplate,
    children:[
      {
        path: '',
        name: 'Home',
        component: () => import('./index.vue'),
        meta:{
          title: 'Home'
        }
      }
    ]
  },
  {
    path: '/Auth',
    component: { render: h => h('router-view')},
    meta: { notLogged: true },
    children: [
      {
        path: 'login',
        name: 'Login',
        component: () => import('./Auth/PgAuth.vue'),
      }
    ]
  },
  {
    path: '/Chatroom/:studentNo?',
    component: { render: h => h('router-view')},
    children: [
      {
        path: '',
        name: 'Chatroom',
        component: () => import('./Chatroom/PgChatroom.vue'),
      }
    ]
  },
  {
    path: '/PendingSchedule',
    component: { render: h => h('router-view')},
    children: [
      {
        path: '',
        name: 'PendingSchedule',
        component: () => import('./C20201/comp/PendingSchedule.vue'),
        meta:{ title: '授業予定' }
      }
    ]
  },
  {
    path: '/ZoomLog',
    component: { render: h => h('router-view')},
    children: [
      {
        path: '',
        name: 'ZoomLog',
        component: () => import('./C40501/comp/ZoomLog.vue'),
        meta:{ title: '履歴' }
      }
    ]
  },
  {
    path: '/t0010',
    component: LetsAdminTemplate,
    children: [
      {
        path: 'list',
        name: 'T0010List',
        component: () => import('./T0010/PgT0010List.vue'),
      },
      {
        path: 'table',
        name: 'T0010Table',
        component: () => import('./T0010/PgT0010Table.vue'),
      },
      {
        path: ':id?/edit',
        name: 'T0010Edit',
        component: () => import('./T0010/PgT0010Edit.vue'),
      }
    ]
  },
  {
    path: '/C00101',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'C00101',
        component: ()=> import('./C00101/PgC00101.vue'),
        meta:{ title: 'お知らせ'}
      }
    ]
  },
  {
    path: '/C00102',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'C00102',
        component: () => import('./C00102/PgC00102.vue'),
        meta:{ title: 'アラート'}
      }
    ]
  },
  {
    path: '/C00103',
    component: LetsAdminTemplate,
    children: [
      {
        path: 'view/:support_no?',
        name: 'C00103',
        component: () => import('./C00103/PgC00103View.vue'),
        meta: {
          title: 'ヘルプ'
        }
      }
    ]
  },
  {
    path: '/C10101',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'C10101Browse',
        component: () => import('./C10101/PgC10101Browse.vue'),
        meta:{
          title: '講師一覧'
        }
      },
      {
        path: ':teacher_id?/edit',
        name: 'C10101Edit',
        component: () => import('./C10101/PgC10101Edit.vue'),
        meta:{
          title: '講師情報'
        }
      },
      {
        path: 'add',
        name: 'C10101Add',
        component: () => import('./C10101/PgC10101Add.vue'),
        meta:{
          title: '講師追加'
        }
      },
    ]
  },
  {
    path: '/C10201',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'C10201',
        component: () => import('./C10201/PgC10201.vue'),
        meta:{ title: '勤務シフト'}
      },
      {
        path: 'teacher/:teacher_no',
        name: 'C10201Teacher',
        component: () => import('./C10201/PgC10201.vue'),
        meta:{ title: '勤務シフト'}
      }
    ]
  },
  {
    path: '/C10301',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'C10301',
        component: () => import('./C10301/PgC10301.vue'),
        meta:{
          title: 'シフト確認'
        }
      }
    ]
  },
  {
    path: '/C20101',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'C20101Browse',
        component: () => import('./C20101/PgC20101Browse.vue'),
        meta:{
          title: '生徒一覧'
        }
      },
      {
        path: ':student_id?/edit',
        name: 'C20101Edit',
        component: () => import('./C20101/PgC20101Edit.vue'),
        meta:{
          title: '生徒情報'
        }
      },
      {
        path: 'add',
        name: 'C20101Add',
        component: () => import('./C20101/PgC20101Add.vue'),
        meta:{
          title: '生徒追加'
        }
      }
    ]
  },
  {
    path: '/C20201',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'C20201Browse',
        component: () => import('./C20201/PgC20201Browse.vue'),
        meta:{
          title: '生徒カルテ一覧'
        }
      },
      {
        path: 'edit/:curriculum_id?',
        name: 'C20201Edit',
        component: () => import('./C20201/PgC20201Edit.vue'),
        meta:{
          title: '生徒カルテ'
        }
      },
      {
        path: 'add',
        name: 'C20201Add',
        component: () => import('./C20201/PgC20201Add.vue'),
        meta:{
          title: '生徒追加'
        }
      },
    ]
  },
  // 0000993
  ...["Draft", "Contract", "Pending", "Denial"].map(status => ({
    path: `/C20201${status}`,
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: `C20201${status}`,
        component: () => import('./C20201/PgC20201Browse.vue'),
        meta:{
          title: '生徒カルテ一覧'
        }
      },
      {
        path: 'edit/:curriculum_id?',
        name: `C20201${status}Edit`,
        component: () => import('./C20201/PgC20201Edit.vue'),
        meta:{
          title: '生徒カルテ'
        }
      },
      {
        path: 'add',
        name: `C20201${status}Add`,
        component: () => import('./C20201/PgC20201Add.vue'),
        meta:{
          title: '生徒追加'
        }
      },
    ]
  })),
  {
    path: '/C20301',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'C20301Browse',
        component: () => import('./C20301/PgC20301Browse.vue'),
        meta:{
          title: '生徒担当センター変更'
        }
      },
    ]
  },
  {
    path: '/C30101',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'C30101',
        component: () => import('./C30101/PgC30101.vue'),
        meta:{
          title: '授業申込'
        }
      },
      {
        path: 'student',
        name: 'C30101Student',
        component: () => import('./C30101Student/PgC30101.vue'),
        meta:{
          title: '追加授業申込・講習申込'
        }
      }
    ]
  },
  {
    path: '/C30201',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'C30201',
        component: () => import('./C30201/PgC30201.vue'),
        meta:{
          title: '申込制限（満席設定）'
        }
      },
    ]
  },
  {
    path: '/C40101',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'C40101',
        component: () => import('./C40101/PgC40101.vue'),
        meta:{
          title: '授業予約割当',
          showFooter: false
        }
      },
    ]
  },
  {
    path: '/C40201',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'C40201',
        component: () => import('./C40201/PgC40201.vue'),
        meta:{ title: '稼働表'}
      },
    ]
  },
  {
    path: '/C40401',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'C40401Browse',
        component: () => import('./C40401/PgC40401Browse.vue'),
        meta:{ title: 'レギュラー必要講師数'}
      }
    ]
  },
  {
    path: '/C40411',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'C40411Browse',
        component: () => import('./C40411/PgC40411Browse.vue'),
        meta:{ title: '生徒要望一覧'}
      }
    ]
  },
  {
    path: '/C40421',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'C40421Browse',
        component: () => import('./C40421/PgC40421Browse.vue'),
        meta:{ title: 'アドバンス'}
      },
      {
        path: 'Image/:schedule_no',
        name: 'C40421Image',
        component: () => import('./C11101/PgC11101Image.vue'),
        meta: { title: '画像データ' },
      }
    ]
  },
  {
    path: '/C40501',
    component: LetsAdminTemplate,
    name: 'C40501',
    redirect: { name: 'C40501Browse' },
    children: [
      {
        path: '',
        name: 'C40501Browse',
        component: () => import('./C40501/PgC40501Browse.vue'),
        meta:{ title: '授業一覧'}
      }
    ]
  },
  {
    path: '/C40701',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'C40701Browse',
        component: () => import('./C40701/PgC40701Browse.vue'),
        meta:{ title: '講師出勤確認一覧'}
      }
    ]
  },
  {
    path: '/C50101',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'C50101Browse',
        component: () => import('./C50101/PgC50101Browse.vue'),
        meta:{ title: '授業報告書承認'}
      },
      {
        path: 'teacher',
        name: 'C50101TeacherBrowse',
        component: () => import('./C50101/PgC50101Browse.vue'),
        meta:{ title: '授業報告書一覧'}
      }
    ]
  },
  {
    path: '/C50102',
    component: LetsAdminTemplate,
    children: [
      {
        path: 'pastReport/:schedule_no?',
        name: 'C50102PastReport',
        component: () => import('./C50102/comp/C50102PastReport.vue'),
        meta:{ title: '過去の授業報告書の参照'}
      },
      {
        path: ':schedule_no',
        name: 'C50102',
        component: () => import('./C50102/PgC50102.vue'),
        meta:{ title: '授業報告書'}
      }
    ]
  },
  {
    path: '/C50103',
    component: LetsAdminTemplate,
    children: [
      {
        path: ':schedule_no?',
        name: 'C50103',
        component: () => import('./C50103/PgC50103.vue'),
        meta:{ title: '授業報告書'}
      }
    ]
  },
  {
    path: '/C11101',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'C11101',
        component: () => import('./C11101/PgC11101.vue'),
        meta: { title: '本日の予定' },
      },
      {
        path: 'Image/:schedule_no',
        name: 'C11101Image',
        component: () => import('./C11101/PgC11101Image.vue'),
        meta: { title: '画像データ' },
      }
    ]
  },
  {
    path: '/C11201',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'C11201',
        component: () => import('./C11201/PgC11201.vue'),
        meta: { title: '今後の予定' },
      },
      {
        path: 'Image/:schedule_no',
        name: 'C11201Image',
        component: () => import('./C11101/PgC11101Image.vue'),
        meta: { title: '画像データ' },
      }
    ]
  },
  {
    path: '/C21101',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'C21101',
        component: () => import('./C21101/PgC21101.vue'),
        meta: { title: '本日の予定' },
      }
    ]
  },
  {
    path: '/C21201',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'C21201',
        component: () => import('./C21201/PgC21201.vue'),
        meta: { title: '今後の予定・授業振替' },
      }
    ]
  },
  {
    path: '/B00101',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'B00101',
        component: { render: h => h('div', '作成中') },
        meta:{ title: '授業割当'}
      }
    ]
  },
  {
    path: '/B00201',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'B00201',
        component: { render: h => h('div', '作成中') },
        meta:{ title: 'Zoom連携'}
      }
    ]
  },
  {
    path: '/B00301',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'B00301',
        component: { render: h => h('div', '作成中') },
        meta:{ title: 'Zoomアカウント割当'}
      }
    ]
  },
  {
    path: '/M00101',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'M00101',
        component: () => import('./M00101/PgM00101Browse.vue'),
        meta:{ title: 'お知らせ一覧'}
      },
      {
        path: 'add',
        name: 'M00101Add',
        component: () => import('./M00101/PgM00101Add.vue'),
        meta:{
          title: 'お知らせ追加'
        }
      },
      {
        path: 'edit/:notice_no',
        name: 'M00101Edit',
        component: () => import('./M00101/PgM00101Edit.vue'),
        meta:{
          title: 'お知らせ情報'
        }
      },
    ]
  },
  {
    path: '/M00201',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'M00201',
        component: () => import('./M00201/PgM00201.vue'),
        meta:{ title: 'レギュラー申込状況'}
      },
    ]
  },
  {
    path: '/M00501',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'M00501Browse',
        component: () => import('./M00501/PgM00501Browse.vue'),
        meta:{ title: '教室動作状況一覧'}
      }
    ]
  },
  {
    path: '/M20101',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'M20101Browse',
        component: () => import('./M20101/PgM20101Browse.vue'),
        meta:{
          title: 'センター一覧'
        }
      },
      {
        path: 'add',
        name: 'M20101Add',
        component: () => import('./M20101/PgM20101Add.vue'),
        meta:{
          title: 'センター追加'
        }
      },
      {
        path: 'edit/:center_no',
        name: 'M20101Edit',
        component: () => import('./M20101/PgM20101Edit.vue'),
        meta:{
          title: 'センター情報'
        }
      }
    ]
  },
  {
    path: '/M20201',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'M20201Browse',
        component: () => import('./M20201/PgM20201Browse.vue'),
        meta: {
          title: '教室一覧'
        }
      },
      {
        path: 'add',
        name: 'M20201Add',
        component: () => import('./M20201/PgM20201Add.vue'),
        meta:{
          title: '教室追加'
        }
      },
      {
        path: ':classroom_no?/edit',
        name: 'M20201Edit',
        component: () => import('./M20201/PgM20201Edit.vue'),
        meta:{
          title: '教室情報'
        }
      },
    ]
  },
  {
    path: '/M20301',
    name: 'M20301',
    component: LetsAdminTemplate,
    redirect: { name: 'M20301Browse' },
    children: [
      {
        path: '',
        name: 'M20301Browse',
        component: () => import('./M20301/PgM20301Browse.vue'),
        meta: {
          title: 'コース一覧'
        }
      },
      {
        path: 'add/:_course_type',
        name: 'M20301Add',
        component: () => import('./M20301/PgM20301Add.vue'),
        children:[
          {
            path: 'M1005',
            name: 'M20301AddM1005',
            component: () => import('./M20301/comp/M1005Edit.vue'),
            meta:{
              title: 'コース種類追加'
            }
          },
          {
            path: 'M1010',
            name: 'M20301AddM1010',
            component: () => import('./M20301/comp/M1010Edit.vue'),
            meta:{
              title: 'コース追加'
            }
          }
        ]
      },
      {
        path: ':id/edit/:_course_type',
        name: 'M20301Edit',
        component: () => import('./M20301/PgM20301Edit.vue'),
        children:[
          {
            path: 'M1005',
            name: 'M20301EditM1005',
            component: () => import('./M20301/comp/M1005Edit.vue'),
            meta:{
              title: 'コース種類情報'
            }
          },
          {
            path: 'M1010',
            name: 'M20301EditM1010',
            component: () => import('./M20301/comp/M1010Edit.vue'),
            meta:{
              title: 'コース情報'
            }
          }
        ]
      },
    ]
  },
  {
    path: '/M20401',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'M20401Browse',
        component: () => import('./M20401/PgM20401Browse.vue'),
        meta: {
          title: '科目一覧'
        }
      },
      {
        path: 'add',
        name: 'M20401Add',
        component: () => import('./M20401/PgM20401Add.vue'),
        meta:{
          title: '科目追加'
        }
      },
      {
        path: ':subject_no?/edit',
        name: 'M20401Edit',
        component: () => import('./M20401/PgM20401Edit.vue'),
        meta:{
          title: '科目情報'
        }
      },
    ]
  },
  {
    path: '/M20601',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'PgM20601BatchEdit',
        component: () => import('./M20601/PgM20601BatchEdit.vue'),
        meta: {
          title: '名称設定'
        }
      },
    ]
  },
  {
    path: '/M20701',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'M20701Browse',
        component: () => import('./M20701/PgM20701Browse.vue'),
        meta: {
          title: '通知メール管理'
        }
      },
      // {
      //   path: 'add',
      //   name: 'M20701Add',
      //   component: () => import('./M20701/PgM20701Add.vue'),
      //   meta:{
      //     title: '通知メール追加'
      //   }
      // },
      {
        path: ':id/edit',
        name: 'M20701Edit',
        component: () => import('./M20701/PgM20701Edit.vue'),
        meta:{
          title: '通知メール情報'
        }
      },
    ]
  },
  {
    path: '/M20801',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'M20801Browse',
        component: () => import('./M20801/PgM20801Browse.vue'),
        meta: {
          title: '講習予定一覧'
        }
      },
      {
        path: 'add',
        name: 'M20801Add',
        component: () => import('./M20801/PgM20801Add.vue'),
        meta:{
          title: '講習予定追加'
        }
      },
      {
        path: 'edit/:seminar_name',
        name: 'M20801Edit',
        component: () => import('./M20801/PgM20801Edit.vue'),
        meta:{
          title: '講習予定情報'
        }
      },
    ]
  },
  {
    path: '/M20901',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'M20901Browse',
        component: () => import('./M20901/PgM20901Browse.vue'),
        meta: {
          title: 'ユーザー一覧'
        }
      },
      {
        path: 'add',
        name: 'M20901Add',
        component: () => import('./M20901/PgM20901Add.vue'),
        meta:{
          title: 'ユーザー追加'
        }
      },
      {
        path: ':user_no?/edit',
        name: 'M20901Edit',
        component: () => import('./M20901/PgM20901Edit.vue'),
        meta:{
          title: 'ユーザー情報'
        }
      },
    ]
  },
  {
    path: '/M21001',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'M21001Browse',
        component: () => import('./M21001/PgM21001Browse.vue'),
        meta: {
          title: 'カレンダー・休業日設定'
        }
      },
      {
        path: 'edit/:year',
        name: 'M21001BatchEdit',
        component: () => import('./M21001/PgM21001BatchEdit.vue'),
        meta: {
          title: 'カレンダー・休業日設定'
        }
      },
    ]
  },
  {
    path: '/M21101',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'M21101Browse',
        component: () => import('./M21101/PgM21101Browse.vue'),
        meta: {
          title: 'ヘルプ設定'
        }
      },
      {
        path: 'edit/:support_no',
        name: 'M21101Edit',
        component: () => import('./M21101/PgM21101Edit.vue'),
        meta: {
          title: 'ヘルプ編集'
        }
      },
    ]
  },
  {
    path: '/M30101',
    component: LetsAdminTemplate,
    children: [
      {
        path: '',
        name: 'M30101Browse',
        component: () => import('./M30101/PgM30101Browse.vue'),
        meta:{
          title: '指導料金一覧'
        }
      }
    ]
  },
  {
    path: '/404',
    name: '404',
    component: () => import('./404/404.vue')
  }
]
